export default {
  annual: {
    GBP: 101.74,
    ILS: 441.55,
    EUR: 114.63,
    SGD: 144.87,
    SAR: 405.26,
    MXN: 1969.4,
    XCD: 291.88,
    AWG: 194.4,
    BMD: 108.0,
    CRC: 60299.43,
    UYU: 4217.63,
    AUD: 159.94,
    CAD: 147.21,
    NZD: 172.89,
    AED: 396.68,
    QAR: 393.23,
    GEL: 227.23,
    TJS: 942.12,
    JPY: 11746.73,
    CZK: 1893.28,
    BND: 115.75,
    MVR: 1327.1,
    PLN: 378.22,
    CLP: 70463.52,
    PAB: 86.4,
    KRW: 112452.19,
    TWD: 2636.73,
    AMD: 33610.46,
    AZN: 146.88,
    BYN: 218.07,
    KZT: 38099.69,
    KGS: 7552.74,
    UZS: 980588.16,
    HUF: 30275.86,
    IDR: 548856.0,
    MOP: 698.52,
    THB: 2996.52,
    HKD: 678.21,
    PEN: 327.85,
    DOP: 3993.12,
    SVC: 629.95,
    GTQ: 562.28,
    HNL: 1775.29,
    VND: 999999.99,
    ZAR: 1308.93,
    BRL: 375.44,
    ALL: 7763.16,
    BAM: 131.97,
    BGN: 131.94,
    RSD: 7907.76,
    UAH: 2659.08,
    AFN: 6372.0,
    DZD: 9811.21,
    AOA: 36246.78,
    BDT: 7521.28,
    XOF: 44260.78,
    BTN: 5939.85,
    BWP: 951.06,
    BIF: 148320.0,
    KHR: 291888.0,
    XAF: 44260.78,
    CVE: 7520.4,
    KMF: 33469.19,
    CDF: 147312.0,
    DJF: 12818.92,
    SZL: 1308.88,
    ETB: 3873.43,
    FJD: 158.97,
    GHS: 918.0,
    GNF: 635400.0,
    LAK: 999999.99,
    LBP: 999999.99,
    LSL: 1325.52,
    LRD: 11448.0,
    MGA: 309216.89,
    MWK: 73946.38,
    MUR: 3337.2,
    MZN: 4543.2,
    MMK: 151188.7,
    NAD: 1326.24,
    NPR: 9503.73,
    PGK: 253.73,
    RWF: 78469.49,
    SCR: 945.57,
    SLL: 999999.99,
    SBD: 592.75,
    SOS: 40932.0,
    LKR: 25774.08,
    TZS: 168408.0,
    TOP: 169.8,
    TND: 227.12,
    UGX: 267822.21,
    XPF: 8114.4,
    YER: 18025.2,
    ZMW: 1434.49,
    PHP: 3944.66,
    ARS: 14223.72,
    MAD: 522.03,
    KES: 6415.92,
    BZD: 101.59,
    BOB: 348.21,
    GYD: 10633.47,
    HTG: 7599.08,
    JMD: 7717.01,
    NIO: 1841.46,
    PYG: 367018.19,
    SRD: 1719.27,
    COP: 244659.24,
    INR: 2968.07,
    TRY: 679.94,
    EGP: 1102.76,
    PKR: 9584.28,
    MYR: 180.00,
    CNY: 741.74,
    USD: 144.00
  },
  monthly: {
    USD: 20.00,
    GBP: 14.13,
    ILS: 61.33,
    EUR: 15.92,
    SGD: 20.12,
    SAR: 56.29,
    MXN: 273.52,
    XCD: 40.54,
    AWG: 27.0,
    BMD: 15.0,
    CRC: 8374.92,
    UYU: 585.78,
    AUD: 22.21,
    CAD: 20.45,
    NZD: 24.01,
    AED: 55.1,
    QAR: 54.62,
    GEL: 31.56,
    TJS: 130.85,
    JPY: 1631.49,
    CZK: 262.95,
    BND: 16.07,
    MVR: 184.32,
    PLN: 52.53,
    CLP: 9786.6,
    PAB: 12.0,
    KRW: 15618.36,
    TWD: 366.21,
    AMD: 4668.12,
    AZN: 20.39,
    BYN: 30.29,
    KZT: 5291.62,
    KGS: 1048.99,
    UZS: 136192.79,
    HUF: 4204.97,
    IDR: 76230.0,
    MOP: 97.02,
    THB: 416.18,
    HKD: 94.2,
    PEN: 45.53,
    DOP: 554.6,
    SVC: 87.49,
    GTQ: 78.09,
    HNL: 246.57,
    VND: 237250.0,
    ZAR: 181.8,
    BRL: 52.14,
    ALL: 1078.22,
    BAM: 18.32,
    BGN: 18.32,
    RSD: 1098.3,
    UAH: 369.32,
    AFN: 885.0,
    DZD: 1362.67,
    AOA: 5034.28,
    BDT: 1044.61,
    XOF: 6147.33,
    BTN: 824.98,
    BWP: 132.09,
    BIF: 20600.0,
    KHR: 40540.0,
    XAF: 6147.33,
    CVE: 1044.5,
    KMF: 4648.5,
    CDF: 20460.0,
    DJF: 1780.41,
    SZL: 181.79,
    ETB: 537.98,
    FJD: 22.08,
    GHS: 127.5,
    GNF: 88250.0,
    LAK: 169450.0,
    LBP: 152500.0,
    LSL: 184.1,
    LRD: 1590.0,
    MGA: 42946.79,
    MWK: 10270.33,
    MUR: 463.5,
    MZN: 631.0,
    MMK: 20998.43,
    NAD: 184.2,
    NPR: 1319.96,
    PGK: 35.24,
    RWF: 10898.54,
    SCR: 131.33,
    SLL: 197500.0,
    SBD: 82.33,
    SOS: 5685.0,
    LKR: 3579.73,
    TZS: 23390.0,
    TOP: 23.58,
    TND: 31.54,
    UGX: 37197.53,
    XPF: 1127.0,
    YER: 2503.5,
    ZMW: 199.24,
    PHP: 547.87,
    ARS: 1975.52,
    MAD: 72.5,
    KES: 891.1,
    BZD: 14.11,
    BOB: 48.36,
    GYD: 1476.87,
    HTG: 1055.43,
    JMD: 1071.81,
    NIO: 255.76,
    PYG: 50974.75,
    SRD: 238.79,
    COP: 33980.44,
    INR: 412.23,
    TRY: 94.44,
    EGP: 153.16,
    PKR: 1331.15,
    MYR: 22.36,
    CNY: 103.02
  }
}
